const MASKED_LINKS_INIT_DONE_ATTR = 'data-ents-masked-links-initialized';
const ACCORDION_LINKS_INIT_DONE_ATTR = 'data-ents-accordion-links-initialized';

export const openMaskedLink = (event: Event) => {
  const currentTarget = event.currentTarget as HTMLElement;
  const href = currentTarget.getAttribute('data-href');
  const target = currentTarget.getAttribute('data-target');
  if (href) {
    event.preventDefault();
    if (target === '_blank') {
      window.open(href, target);
    } else {
      window.location.href = href;
    }
  }
};

export const initMaskedLinks = (container: Element) => {
  if (container.getAttribute(MASKED_LINKS_INIT_DONE_ATTR) === 'true') {
    return;
  }
  container.querySelectorAll('button[data-href]').forEach((element) => {
    element.addEventListener('click', openMaskedLink);
  });
  container.setAttribute(MASKED_LINKS_INIT_DONE_ATTR, 'true');
};

const openAccordionLink = (event: Event) => {
  const target = (event.currentTarget as HTMLElement).getAttribute('data-accordion-target');
  const targetElement = document.getElementById(`accordion-${target}`);

  if (targetElement) {
    targetElement.setAttribute('open', '');
    const elementY = targetElement.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: elementY,
      behavior: 'smooth',
    });

    const focusElement = targetElement.children.item(0) as HTMLElement;

    focusElement.focus({ preventScroll: true });
  }
};

export const initAccordionLinks = (container: Element) => {
  if (container.getAttribute(ACCORDION_LINKS_INIT_DONE_ATTR) === 'true') {
    return;
  }
  container.querySelectorAll('button[data-accordion-target]').forEach((element) => {
    element.addEventListener('click', openAccordionLink);
  });
  container.setAttribute(MASKED_LINKS_INIT_DONE_ATTR, 'true');
};

export const initLinks = (container: Element) => {
  initMaskedLinks(container);
  initAccordionLinks(container);
};
